import XIcon from "@mui/icons-material/X";
import { type FC, useState } from "react";

import * as Styled from "./XSharePreview.styles";

interface IXSharePreviewProps {
  text: string;
  hashtags: string | null;
  url: string;
  cardSrc: string | null;
}

type CardStatus = "loading" | "loaded" | "failed";

const CardImage: FC<{ src: string }> = ({ src }) => {
  const [status, setStatus] = useState<CardStatus>("loading");

  if (status === "failed") {
    return null;
  }

  return (
    <Styled.CardFrame>
      {status === "loading" && <Styled.CardSkeleton variant="rectangular" />}
      <Styled.Card
        src={src}
        alt=""
        crossOrigin="anonymous"
        $visible={status === "loaded"}
        onLoad={() => setStatus("loaded")}
        onError={() => setStatus("failed")}
      />
    </Styled.CardFrame>
  );
};

export const XSharePreview: FC<IXSharePreviewProps> = ({
  text,
  hashtags,
  url,
  cardSrc,
}) => (
  <Styled.Root>
    <Styled.TopBar>
      <XIcon fontSize="small" />
      <Styled.Drafts>Drafts</Styled.Drafts>
    </Styled.TopBar>

    <Styled.Body>
      <Styled.Avatar />
      <Styled.Content>
        <Styled.Text>{text}</Styled.Text>
        {hashtags && <Styled.Text>{hashtags}</Styled.Text>}
        <Styled.Link>{url.replace(/^https?:\/\//, "")}</Styled.Link>
        {cardSrc && <CardImage key={cardSrc} src={cardSrc} />}
      </Styled.Content>
    </Styled.Body>
  </Styled.Root>
);
